import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, tPath } from "../i18n/translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  toggle: () => {},
  t: (k) => k,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("yoshitaka_lang") || "en";
  });

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
    localStorage.setItem("yoshitaka_lang", lang);
  }, [lang]);

  const toggle = () => setLang((l) => (l === "en" ? "es" : "en"));

  const t = (path) => tPath(translations[lang] || translations.en, path);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
